const STATUS_COLORS = {
  valid: { bg: '#e8f0e5', text: '#6B8063' },
  expiring: { bg: '#fdf3d7', text: '#D4A017' },
  expired: { bg: '#fde8e8', text: '#C0392B' },
  planned: { bg: '#dbeafe', text: '#3498DB' },
  completed: { bg: '#e8f0e5', text: '#6B8063' },
  'in-progress': { bg: '#fdf3d7', text: '#D4A017' },
  active: { bg: '#e8f0e5', text: '#6B8063' },
  inactive: { bg: '#f0ece4', text: '#B2AB9C' },
};

export default function Badge({ status, text }) {
  const label = text || status;
  const key = (status || '').toLowerCase();
  const colors = STATUS_COLORS[key] || { bg: '#f0ece4', text: '#B2AB9C' };

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '3px 12px',
        fontSize: '0.75rem',
        fontWeight: 600,
        borderRadius: '999px',
        backgroundColor: colors.bg,
        color: colors.text,
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
